import { render, staticRenderFns } from "./select-section-template.vue?vue&type=template&id=30a532cc&scoped=true&"
import script from "./select-section-template.vue?vue&type=script&lang=js&"
export * from "./select-section-template.vue?vue&type=script&lang=js&"
import style0 from "./select-section-template.vue?vue&type=style&index=0&id=30a532cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a532cc",
  null
  
)

export default component.exports